import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { useAPI } from '@providers/useAPI';
import { AdminService } from 'app/API';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Content } from './styles/Content';
import { TProps } from './types';

export const UpdateClassifiedErrorDescriptionModal = ({ onCancel, onSuccess, id }: TProps) => {
  const { call } = useAPI();
  const [description, setDescription] = useState('');

  const updateDescription = async () => {
    call(AdminService.updateClassifiedErrorDescription({ errorId: id, requestBody: { description } }), {
      onError: (message) => toast.error(message),
      onSuccess: () => {
        toast.success('Error description updated!');
        onSuccess();
        onCancel();
      },
    });
  };

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Classified Error Description</ModalTitle>

      <Content>
        <Input
          className="mt-4 min-h-24"
          label="Error description"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setDescription(event.target.value)}
          value={description}
          size={32}
        />

        <div className="buttonWrapper w-full max-w-[70%] self-end">
          <OutlinedButton onClick={() => onCancel()}>Cancel</OutlinedButton>
          <Button onClick={updateDescription}>Update</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
